"use strict";

import angular from "angular";

import template from "./others-contacts-import.component.html";
import "./others-contacts-import.component.scss";

import { CompanyContact } from "../../../entity/CompanyContact";
import { CompanyContactHttpGateway } from "../../../gateway/CompanyContact/CompanyContactHttpGateway";
import { Events } from "../../../presentation/services/Events/Events";
import { OthersContactsImportSpreadSheetRead } from "../../../presentation/services/OthersContactsImportSpreadSheetRead/OthersContactsImportSpreadSheetRead";
import { OthersContactsImportSpreedSheetGenerator } from "../../../presentation/services/OthersContactsImportSpreedSheetGenerator/OthersContactsImportSpreedSheetGenerator";

class OthersContactsImportComponent {
    CompanyContactHttpGateway = new CompanyContactHttpGateway();
    Events = new Events();
    file = {};
    dropOptions = {
        multiple: false,
        allowDir: false,
        accept: ".xlsx,.xls",
        maxFiles: 1,
        maxSize: "5MB"
    };
    tabStepIndex = 0;
    loading = false;
    contacts = [];
    formContactsImport = {};
    hasError = false;
    loadingFile = false;
    companiesCount = 0;
    constructor($scope, LoaderService, DesnuDialogService) {
        this.$scope = $scope;
        this.LoaderService = LoaderService;
        this.DesnuDialogService = DesnuDialogService;
    }

    $onInit() {}

    async onDropFile(files) {
        if (!files?.length) return;
        this.loadingFile = true;
        this.file = files[0];
        const othersContactsImportSpreadSheetRead = new OthersContactsImportSpreadSheetRead();
        const contacts = await othersContactsImportSpreadSheetRead.execute({
            file: this.file
        });
        console.log(contacts);
        if (!contacts?.length) {
            this.hasError = true;
        } else {
            this.hasError = false;
        }
        this.loadingFile = false;
        this.$scope.$applyAsync();
    }

    onCancel() {
        this.afterCancel();
        this.hasError = false;
        this.sidenavInstance.close();
    }

    async onSendFile() {
        this.tabStepIndex = 1;
        const othersContactsImportSpreadSheetRead = new OthersContactsImportSpreadSheetRead();
        const contacts = await othersContactsImportSpreadSheetRead.execute({
            file: this.file
        });
        this.contacts = contacts.map((c) => {
            const contact = {
                name: c.name,
                email: c.email,
                companyId: c.company.name,
                company: c.company.name,
                accountingId: this.accountingData._id,
                type: "others",
                relations: {},
                viewModel: {
                    companyName: c.company.name
                }
            };
            return CompanyContact.restore(contact);
        });
        this.afterSendFile();
        this.hasError = false;
        this.$scope.$applyAsync();
    }

    onReturnStep() {
        this.tabStepIndex = 0;
    }

    async onSave() {
        this.LoaderService.setProgress(true);
        this.loading = true;
        const contactsList = angular.copy(this.contacts);
        const contacts = contactsList.map((contact) => {
            contact.transformRelations();
            const props = contact.getProps();
            props.company = props.viewModel.companyName;
            props.companyId = props.viewModel.companyName;
            delete props.viewModel;
            return props;
        });
        await this.CompanyContactHttpGateway.saveMany({
            accountingId: this.accountingData._id,
            type: "others",
            contacts
        });
        this.loading = false;
        this.LoaderService.setProgress(false);
        this.Events.setParamns({
            accountingId: this.accountingData._id,
            contatosSalvos: contacts?.length || 0
        });
        this.Events.send("contatos.outros.enviar.importacao");
        this.$scope.$applyAsync();
        this.afterSave();
    }

    onRemoveContact(index) {
        this.contacts.splice(index, 1);
    }

    onRemoveFile() {
        this.file = {};
        this.hasError = false;
    }

    async onDownloadSpreadSheet() {
        this.LoaderService.setProgress(true);
        this.loading = true;
        const otherContactsImportSpreadSheetGenerator = new OthersContactsImportSpreedSheetGenerator();
        await otherContactsImportSpreadSheetGenerator.execute({
            accountingId: this.accountingData._id
        });
        this.loading = false;
        this.LoaderService.setProgress(false);
        this.$scope.$applyAsync();
    }

    onTryAgain() {
        const element = document.getElementsByClassName(
            "contacts-import-drop-area"
        );
        element.item(0).click();
    }
}

export { OthersContactsImportComponent };

OthersContactsImportComponent.$inject = [
    "$scope",
    "LoaderService",
    "DesnuDialogService"
];

const name = "othersContactsImportComponent";
const def = {
    bindings: {
        afterCancel: "&",
        afterSendFile: "&",
        afterSave: "&",
        accountingData: "<",
        sidenavInstance: "<"
    },
    controller: OthersContactsImportComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
